import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MessageOutlined, FileDoneOutlined, PaperClipOutlined } from '@ant-design/icons';
import ButtonComponent from 'components/Button';
import { useHistory } from 'react-router-dom';
import { fetchStatusModal, fetchSetReloadCaptcha } from 'store/fetchActions/fetchApp';
import { fetchSalvarInputsFormularios } from 'store/fetchActions/fetchInputForm';
import CardGerericoResumo from 'containers/RequerimentoResumo/cardGerericoResumo';
import CardEndereco from 'containers/RequerimentoResumo/cardEndereco';
import CardDadosPessoais from 'containers/RequerimentoResumo/cardDadosPessoais';
import CardDadosProfissionais from 'containers/RequerimentoResumo/cardDadosProfissionais';
import { submitRequerimentoInput, sucessoRequerimento } from './submitForm';
import { duvidas, servicos } from 'routes/paths';
import { ENUM_MODAL } from 'utils/consts';
import { removeTagsHtmlDeTexto } from 'utils/stringFormatter';
import * as S from './style';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export default function PageResumo() {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);
  const inputDados = useSelector(state => state.inputs.inputDadosRequerimentoCompleto);
  const inputSelectOptionsServicos = useSelector(state => state.inputs.inputSelectOptionsServicos);

  const [loadingEnviar, setLoadingEnviar] = React.useState(false);

  const formatarArquivoNome = arquivos => {
    const nomesArquivos = arquivos?.map(x => x.name);
    return nomesArquivos.toString().replace(',', ' - ');
  };

  const validarCaptchaEnviar = () => {
    dispatch(
      fetchStatusModal(true, ENUM_MODAL.RESOLVE_CAPTCHA, {
        onOk: onSubmit,
        titleButton: 'Validar',
        width: 400,
      })
    );
  };

  const onSubmit = () => {
    setLoadingEnviar(true);
    dispatch(submitRequerimentoInput(inputDados?.data, inputDados?.arquivos?.arquivos, inputDados?.assuntoId))
      .then(respostaApi => {
        dispatch(sucessoRequerimento(respostaApi, history, user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE));
        dispatch(fetchSalvarInputsFormularios({}));
      })
      .catch(() => {
        dispatch(fetchStatusModal(false, ''));
        dispatch(fetchSetReloadCaptcha(true));
      })
      .finally(() => {
        setLoadingEnviar(false);
      });
  };

  const onBack = () => {
    history.push(inputDados?.data?.servico ? servicos : duvidas);
  };

  return (
    <S.Contain className="boxShadow">
      <S.Card>
        <div style={{ textAlign: 'center', margin: 'auto', width: '70%' }}>
          <S.Titulo>
            <h1>FAS</h1>
            <h3>Resumo do Requerimento</h3>
            <p>
              Antes de enviar o requerimento, verifique se os dados estão corretos e se atendem os requisitos
              necessários para prosseguir com o atendimento. Verifique também, se necessário, os anexos solicitados e os
              anexos enviados. Caso tenha alguma inconsistência no seu requerimento, ele poderá ser cancelado ou
              devolvido para ajustes. Após o envio do requerimento, é possível acompanhar o seu status a qualquer
              momento.
            </p>
          </S.Titulo>
        </div>
        {inputDados?.data?.servico && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CardGerericoResumo
              titulo="Descrição do Serviço"
              descricao={inputSelectOptionsServicos?.find(x => x.id === inputDados?.data?.servico)?.descricao}
              icon={<MessageOutlined />}
            />
            <CardGerericoResumo
              titulo="Documentos necessário"
              descricao={removeTagsHtmlDeTexto(
                inputSelectOptionsServicos?.find(x => x.id === inputDados?.data?.servico)?.documentos
              )}
              icon={<FileDoneOutlined />}
            />
            <CardGerericoResumo
              titulo="Documentos anexados"
              descricao={formatarArquivoNome(inputDados?.arquivos?.arquivos)}
              icon={<PaperClipOutlined />}
            />
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CardEndereco dadosInputs={inputDados?.data} />
          <CardDadosPessoais dadosInputs={inputDados?.data} />
          <CardDadosProfissionais dadosInputs={inputDados?.data} />
        </div>
        <CardGerericoResumo
          style={{ width: '89%', margin: 'auto' }}
          titulo="Justificativa"
          descricao={inputDados?.data?.justificativa}
          icon={<MessageOutlined />}
        />
        <S.ContainerButton>
          <ButtonComponent text={'Voltar'} clickAction={onBack} css={{ margin: '10px' }} />
          <ButtonComponent
            text={'Enviar'}
            clickAction={validarCaptchaEnviar}
            css={{ margin: '10px' }}
            loading={loadingEnviar}
          />
        </S.ContainerButton>
      </S.Card>
    </S.Contain>
  );
}
